import { render, staticRenderFns } from "./JdhLogicalColorPicker.vue?vue&type=template&id=591fd8bb&scoped=true&"
import script from "./JdhLogicalColorPicker.vue?vue&type=script&lang=ts&"
export * from "./JdhLogicalColorPicker.vue?vue&type=script&lang=ts&"
import style0 from "./JdhLogicalColorPicker.vue?vue&type=style&index=0&id=591fd8bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "591fd8bb",
  null
  
)

export default component.exports